var React = require('react');
var _ = require('underscore');
var $ = require('jquery')
var moment =require('moment');

var T = React.PropTypes;


var NotifyItem = React.createClass({

    propTypes: {
        /**
         * 指定两条通知的间距
         */
        spacing: T.number,
        /**
         * 信息的内容
         */
        content: T.string,
        /**
         * 引用 id
         */
        refID : T.string,
        onClose: T.func,
    },
    componentWillMount(){
        this.date = moment().format('YYYY-MM-DD H:mm:ss');
    },
    close(){
        this.props.onClose();
    },
    getDefaultProps(){
        return {
            spacing: 20,
            onClose: ()=>{},
            content: ""
        }
    },
    getInitialState(){
        return {
        }
    },
    render(){

        var itemStyle  = {
            marginBottom: this.props.spacing + 'px'
        };

        return (
            <div className="mod-gin-notify" style={itemStyle}>
                <i className="fcon-close close" onClick={ this.close }></i>
                <div className="content">
                    <img width="40" height="40" src="//f5.jiejiatech.net/y16/0725/1713/00zqs_o.png" className="pic"/>
                    <div className="text">
                        <h3 className="title">{ this.props.content }</h3>
                        <p><span className="info">{this.date}</span></p>
                    </div>
                </div>
            </div>
        )
    }
});

module.exports = NotifyItem;



/** WEBPACK FOOTER **
 ** ./script/cutil/gin-notify/notify-item.jsx
 **/